import {capitalize, parseParams} from '../resources/utils';
import {getIncident} from '../layers/incidents';
import {getPerimeter} from '../layers/perimeters';
import {getEvacZoneBbox} from '../layers/evacuation-zones';
import {firePerimeterLabel} from '../layers/detail-perimeter-label';
import {createDetailCard} from '../detail-info/detail-card';
import {drawInset} from '../detail-info/ca-inset';
import {flyToCoords, flyToBbox} from './fly';
import {apnumber} from 'journalize';
import * as turf from '@turf/turf';

export const combineShapes = (perimeter, evacZoneBbox) => {
  const fc = {
    type: 'FeatureCollection',
    features: [perimeter, evacZoneBbox]
  };
  const bbox = turf.bbox(fc);
  const bboxPolygon = turf.bboxPolygon(bbox);
  return bboxPolygon;
}

export const zoomToQueryParamsIndex = (params) => {
  const paramDict = parseParams(params);
  if(paramDict['fire']){
    const perimeter = getPerimeter(paramDict['fire']);
    const evacZoneBbox = getEvacZoneBbox(paramDict['fire']);
    if(perimeter && evacZoneBbox){
      const cShape = combineShapes(perimeter, evacZoneBbox);
      flyToBbox(cShape.geometry.coordinates[0], 0);
    } else if(evacZoneBbox){
      flyToBbox(evacZoneBbox.geometry.coordinates[0], 0);
    } else if(perimeter){
      flyToBbox(perimeter.properties.bbox, 0);
    } else {
      const incident = getIncident(paramDict['fire']);
      if(incident){
        let zoom = 10;
        if(paramDict['zoom']){
          zoom = paramDict['zoom'];
        }
        flyToCoords(incident.geometry.coordinates[0], incident.geometry.coordinates[1], zoom, true, 0);
      }
    }
    const cFire = document.getElementById(`card-${paramDict['fire']}`);
    cFire.classList.add("active");
    // Scroll to the item in the list
    cFire.scrollIntoView({
      block: "start",
      behavior: "smooth"
    });
  } else if(paramDict['bbox']){
    // [[-118.352815,33.915875],[-118.245958,34.051695]]
    // bottom left corner, top right corner
    flyToBbox(JSON.parse(paramDict['bbox']), 0);
  } else if(paramDict['zoom'] || paramDict['point']){
    if(paramDict['zoom'] && paramDict['point']){
      const pointArray = paramDict['point'].split(',');
      flyToCoords(parseFloat(pointArray[0]), parseFloat(pointArray[1]), paramDict['zoom'], true, 0);
    } else if(paramDict['point']){
      const pointArray = paramDict['point'].split(',');
      flyToCoords(parseFloat(pointArray[0]), parseFloat(pointArray[1]), 10, true, 0);
    } else if(paramDict['zoom']){
      window.fireMap.setZoom(paramDict['zoom']);
    }
  }
}

/* Initial sizing of the map */
export const zoomToQueryParamsDetail = (params) => {
    // based on params from url
    const paramDict = parseParams(params);
    const caFiresCt = window.fireData.fireList.filter(f => {
      return f.state === 'CA';
    }).length;
    let caPluralDetail = `${apnumber(caFiresCt)} fires`;
    if(caFiresCt <= 1){
      caPluralDetail = 'fires';
    }
    document.getElementById('ca-fire-num').innerHTML = caPluralDetail;
    if(paramDict['fire'] && paramDict['point']){
      const pointArray = paramDict['point'].split(',');
      let zoom = 10;
      if(paramDict['zoom']){
        zoom = paramDict['zoom'];
      }
      flyToCoords(parseFloat(pointArray[0]), parseFloat(pointArray[1]), zoom, true, 0, 'detail');
      let info = window.fireData.fireList.find(function(item) {
        return item.slug === paramDict['fire'].toLowerCase();
      });
      createDetailCard(info);
      if(info.state === 'CA'){
        drawInset(info.acres, [parseFloat(info.x), parseFloat(info.y)]);
      } else {
        document.getElementById('detail-card').style.display = 'flex';
      }

    } else if (paramDict['fire']){
      let perimeter = getPerimeter(paramDict['fire']);
      const evacZoneBbox = getEvacZoneBbox(paramDict['fire']);
      if(perimeter && evacZoneBbox){
        const cShape = combineShapes(perimeter, evacZoneBbox);
        flyToBbox(cShape.geometry.coordinates[0], 0, 'detail');
        firePerimeterLabel(perimeter, paramDict['anchor-position']);
      } else if(evacZoneBbox){
        flyToBbox(evacZoneBbox.geometry.coordinates[0], 0, 'detail');
      } else if(perimeter){
        flyToBbox(perimeter.properties.bbox, 0, 'detail');
        firePerimeterLabel(perimeter, paramDict['anchor-position']);
      } else {
        perimeter = getIncident(paramDict['fire']);
        let zoom = 10;
        if(paramDict['zoom']){
          zoom = paramDict['zoom'];
        }
        flyToCoords(perimeter.geometry.coordinates[0], perimeter.geometry.coordinates[1], zoom, true, 0, 'detail');
      }
      if(perimeter || evacZoneBbox){
        let info = window.fireData.fireList.find(function(item) {
          return item.slug === paramDict['fire'].toLowerCase();
        });
        createDetailCard(info);
        if(info.state === 'CA'){
          drawInset(info.acres, [parseFloat(info.x), parseFloat(info.y)]);
        } else {
          document.getElementById('detail-card').style.display = 'flex';
        }
      } else {
        document.getElementById('detail-cont').style.display = 'none';
        document.getElementById('fallback').style.display = 'block';
        document.getElementById('fire-name-fallback').innerHTML = capitalize(paramDict['fire']);
      }
    } else if(paramDict['bbox']){
      // [[-118.352815,33.915875],[-118.245958,34.051695]]
      // bottom left corner, top right corner
      flyToBbox(JSON.parse(paramDict['bbox']), 0, 'detail');
    } else if(paramDict['zoom'] || paramDict['point']){
      if(paramDict['zoom'] && paramDict['point']){
        const pointArray = paramDict['point'].split(',');
        flyToCoords(parseFloat(pointArray[0]), parseFloat(pointArray[1]), paramDict['zoom'], true, 0, 'detail');
      } else if(paramDict['point']){
        const pointArray = paramDict['point'].split(',');
        flyToCoords(parseFloat(pointArray[0]), parseFloat(pointArray[1]), 10, true, 0, 'detail');
      } else if(paramDict['zoom']){
        window.FireMap.setZoom(paramDict['zoom']);
      }
    }
}
